import { Component, Input, OnInit } from '@angular/core';
import { Settings } from '../models/Settings';
import { InitalizeService } from '../services/initalize.service';
import { Router } from '@angular/router';

@Component({
    selector: 'pi-slide-menu',
    templateUrl: './slide-menu.component.html',
    styleUrls: ['./slide-menu.component.scss'],
    standalone: false
})
export class SlideMenuComponent implements OnInit {

  @Input() settings: Settings;
  showMenu = false;

  constructor(private initializeService: InitalizeService, private router: Router) { }

  ngOnInit() {
  }

  navigateTo(url) {
    this.router.navigateByUrl(url).then(() => {
      this.hideMenu();
    });
  }

  openDisclaimer() {
    this.initializeService.setShowDisclaimer(true);
    this.hideMenu();
  }

  public hideMenu() {
    this.showMenu = !this.showMenu;
  }


}
